import * as tslib_1 from "tslib";
import { AuthService } from "./auth.service";
import { environment } from "../../environments/environment";
const ACTIVITY_EVENTS = ["mousemove", "keydown", "click", "scroll", "touchstart"];
/** Check inactivity every 30 seconds so we detect timeout soon after it elapses. */
const INACTIVITY_CHECK_INTERVAL_MS = 30 * 1000;
export class SessionHeartbeatService {
    constructor(authService) {
        this.authService = authService;
        this.lastActivity = Date.now();
        // private warningShown = false; // Unused when warning popup is commented out
        this.timer = null;
        this.expiring = false;
        this.started = false;
        this.cfg = null;
        this.baseUrl = "";
        ACTIVITY_EVENTS.forEach((evt) => document.addEventListener(evt, () => {
            this.lastActivity = Date.now();
            // this.warningShown = false; // Unused when warning popup is commented out
        }, { passive: true }));
    }
    start() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (this.started || !this.authService.authenticated)
                return;
            this.started = true;
            const cfg = yield this.loadConfig();
            if (!cfg || !cfg.authAuthority)
                return;
            this.cfg = cfg;
            this.baseUrl = (environment.baseFixUrl || "").replace(/\/+$/, "");
            this.checkInactivity();
            this.timer = window.setInterval(() => this.checkInactivity(), INACTIVITY_CHECK_INTERVAL_MS);
            // Heartbeat commented out for now - uncomment ping() and use it instead of checkInactivity to re-enable
        });
    }
    stop() {
        if (this.timer != null) {
            window.clearInterval(this.timer);
            this.timer = null;
        }
        this.started = false;
    }
    loadConfig() {
        const baseUrl = (environment.baseFixUrl || "").replace(/\/+$/, "");
        const url = baseUrl ? `${baseUrl}/api/session/config` : "";
        if (!url)
            return Promise.resolve(null);
        return fetch(url, { method: "GET", credentials: "include" })
            .then((res) => (res.ok ? res.json() : null))
            .catch(() => null);
    }
    getLogoutRedirectUrl() {
        const logoutUrl = this.cfg && this.cfg.logoutUrl ? this.cfg.logoutUrl : null;
        if (!logoutUrl)
            return Promise.resolve(null);
        const fullUrl = logoutUrl.startsWith("http") ? logoutUrl : `${this.baseUrl}${logoutUrl}`;
        return fetch(fullUrl, { method: "GET", credentials: "include" })
            .then((res) => (res.ok ? res.json() : null))
            .then((data) => data && data.Success && typeof data.Data === "string" ? data.Data : null)
            .catch(() => null);
    }
    buildLoginUrl() {
        const authAuthority = (this.cfg && this.cfg.authAuthority) || "";
        const returnUrl = window.location.href;
        return `${authAuthority}/Login?returnUrl=${encodeURIComponent(returnUrl)}`;
    }
    checkInactivity() {
        if (!this.cfg || !this.authService.authenticated || this.expiring)
            return;
        const inactivityMs = (this.cfg.inactivityMinutes != null ? this.cfg.inactivityMinutes : 30) * 60 * 1000;
        const idleMs = Date.now() - this.lastActivity;
        if (idleMs >= inactivityMs) {
            this.expiring = true;
            this.stop();
            this.getLogoutRedirectUrl().then((redirectUrl) => {
                const url = redirectUrl || this.buildLoginUrl();
                this.authService.logout();
                window.location.href = url;
            });
        }
    }
}
